import { safeSessionGetItem, safeSessionRemoveItem, safeSessionSetItem } from './localStorage'

// Intención post-auth del signup: evita la carrera de routers entre el
// `push('/onboarding')` del form de signup y el `push('/dashboard')` ciego
// de la login page ante cualquier `user`.
//
// Se marca ANTES del await de Firebase (valor 'onboarding') para ganar la
// carrera; tras createUser se liga al uid. Peek, no consume.
// Un flag huérfano de otra carga (F5 a medias) solo se honra si el uid
// almacenado coincide con el user actual — si no, fallback a /dashboard.
export const POST_AUTH_INTENT_KEY = 'barmanager.postAuthIntent'

const ONBOARDING_INTENT_VALUE = 'onboarding'

let markedThisLoad = false

export const markOnboardingIntent = (uid?: string | null): boolean => {
  markedThisLoad = true
  return safeSessionSetItem(POST_AUTH_INTENT_KEY, uid || ONBOARDING_INTENT_VALUE)
}

export const clearPostAuthIntent = (): boolean => {
  markedThisLoad = false
  return safeSessionRemoveItem(POST_AUTH_INTENT_KEY)
}

export const hasOnboardingIntent = (uid?: string | null): boolean => {
  const stored = safeSessionGetItem(POST_AUTH_INTENT_KEY)
  if (!stored) return false
  if (uid && stored === uid) return true
  if (markedThisLoad && stored === ONBOARDING_INTENT_VALUE) return true
  if (!uid && markedThisLoad && stored) return true
  return false
}

export const pathForPostAuthIntent = (uid?: string | null): '/onboarding' | '/dashboard' =>
  hasOnboardingIntent(uid) ? '/onboarding' : '/dashboard'
